import React, { useEffect } from "react";
import { WhiteLabelDataTable } from "./WhitelabelDataTable";
import { setDynamicTitle } from "../../Utils/dynamicTitleManager";

export const WhitelabelList = () => {
  // Use dynamic title management
  useEffect(() => {
    setDynamicTitle("Whitelabel List");
  }, []);

  return <div>
    <WhiteLabelDataTable />
  </div>;
};